function LoginFail() {
  return <div>Failed to log in...</div>;
}
export default LoginFail;
